/** Calendar: Agenda, WeekView, MonthView, EventDialog, CalendarHeader, DueDate, EventLinksPanel. */
export const calendar = {
  'calendar.header.previous': 'Previous',
  'calendar.header.next': 'Next',
  'calendar.header.today': 'Today',
  'calendar.event.noCategory': 'No category',
  'calendar.event.startTime': 'Start time',
  'calendar.event.endTime': 'End time',

  // CalendarHeader
  'calendar.nav.label': 'Calendar views',
  'calendar.tabs.agenda': 'Agenda',
  'calendar.tabs.week': 'Week',
  'calendar.tabs.month': 'Month',
  'calendar.event.new': 'New event',

  // EventDialog
  'calendar.event.edit': 'Edit event',
  'calendar.event.titleLabel': 'Title',
  'calendar.event.titlePlaceholder': 'Meet the Guildmaster',
  'calendar.event.allDay': 'All day',
  'calendar.event.start': 'Start',
  'calendar.event.end': 'End',
  'calendar.event.clearEnd': 'Clear the end',
  'calendar.event.noEndTitle': 'No end',
  'calendar.event.addEnd': 'No end — add one',
  'calendar.event.endError': 'The end must be after the start.',
  'calendar.event.runsThrough': 'Runs through {date}, inclusive.',
  'calendar.event.categoryLabel': 'Category',
  'calendar.event.descriptionLabel': 'Description',
  'calendar.event.pagesLabel': 'Pages',
  'calendar.event.unlinkPage': 'Unlink {title}',
  'calendar.event.linkPage': 'Link a page',
  'calendar.event.searchPages': 'Search pages…',
  'calendar.event.noPagesMatch': 'No pages match “{query}”.',
  'calendar.event.doneLabel': 'Done',
  'calendar.event.doneSuffix': ' (done)',
  'calendar.event.discardTitle': 'Discard this event?',
  'calendar.event.discardDescription': 'You have unsaved changes. Closing now throws them away.',
  'calendar.event.keepEditing': 'Keep editing',
  'calendar.event.discard': 'Discard',
  'calendar.event.deleteTitle': 'Delete “{title}”?',
  'calendar.event.deleteFallbackTitle': 'this event',
  'calendar.event.deleteDescription':
    'Events are deleted permanently — there is no event trash. The pages it links to are not touched.',
  'calendar.event.fallbackLabel': 'event',

  // Agenda
  'calendar.agenda.title': 'Next {days} days',
  'calendar.agenda.overdueLabel': 'Overdue',
  'calendar.agenda.overdueHeading': 'Overdue ({count})',
  'calendar.agenda.emptyState': 'Nothing scheduled for the next 7 days.',
  'calendar.agenda.today': 'Today ·',
  'calendar.agenda.newEventOn': 'New event on {date}',
  'calendar.agenda.markDone': 'Mark “{title}” done',
  'calendar.agenda.markNotDone': 'Mark “{title}” not done',
  'calendar.agenda.allDay': 'all-day',
  'calendar.agenda.dayOfSpan': 'Day {day} of {span}',

  // WeekView
  'calendar.week.newEventAria': 'New event on {date} — click an hour, or drag a range',

  // MonthView
  'calendar.month.more': '+{count} more',

  // DueDate / DueDateForm
  'calendar.due.setPrompt': 'Set a due date',
  'calendar.dueOn': 'Due {date}',
  'calendar.due.buttonLabel': 'Due date',
  'calendar.due.time': 'Due time',
  'calendar.due.clear': 'Clear',
  'calendar.due.fallbackLabel': 'due date',
  'calendar.due.titlePrefix': 'Due: {title}',

  // EventLinksPanel
  'calendar.links.ariaLabel': 'Referenced by events',
  'calendar.links.referencedBy.one': 'Referenced by {count} event',
  'calendar.links.referencedBy.other': 'Referenced by {count} events',
  'calendar.links.openAgenda': 'Open the agenda',

  // Category (useEventCategories.ts)
  'calendar.category.fallbackLabel': 'category',

  // Toasts
  'calendar.toast.createError': "Couldn't create the event.",
  'calendar.toast.updateError': "Couldn't save the event.",
  'calendar.toast.deleteError': "Couldn't delete the event.",
  'calendar.toast.toggleError': "Couldn't update the event.",
  'calendar.toast.dueError': "Couldn't set the due date.",
  'calendar.toast.categoryCreateError': "Couldn't create the category.",
  'calendar.toast.categoryUpdateError': "Couldn't save the category.",
  'calendar.toast.categoryDeleteError': "Couldn't delete the category.",
} as const;
